
const Volunteer = () => {
  return <div style={{ margin: "3rem 10rem" }}></div>;
};

export default Volunteer;
